import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "8ad4eb17-bfd7-4251-88d1-6f415901827c"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter8ad4eb17Bfd7425188d16f415901827c(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter8ad4eb17Bfd7425188d16f415901827c footer`}>
      {props["links"] || <Navigation className="LinksE7a2b901Dd304538A0be3594c02e0ba2" parentTag={buildClassName("LinksE7a2b901Dd304538A0be3594c02e0ba2", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="LogoFb7114b9A151473692064b6c312b2c6f" parentTag={buildClassName("LogoFb7114b9A151473692064b6c312b2c6f", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright84c28799418d4a24Ad0289586903bd50" parentTag={buildClassName("Copyright84c28799418d4a24Ad0289586903bd50", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow97075f2eA84448e4B43d208d7fa5126b" parentTag={buildClassName("Groupflow97075f2eA84448e4B43d208d7fa5126b", parentTag)} {...props} />}
    </footer>
  );
}

// id: "fb7114b9-a151-4736-9206-4b6c312b2c6f"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "8ad4eb17-bfd7-4251-88d1-6f415901827c"
export function LogoFb7114b9A151473692064b6c312b2c6f(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoFb7114b9A151473692064b6c312b2c6f" parentTag={buildClassName("LogoFb7114b9A151473692064b6c312b2c6f", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "84c28799-418d-4a24-ad02-89586903bd50"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "8ad4eb17-bfd7-4251-88d1-6f415901827c"
export function Copyright84c28799418d4a24Ad0289586903bd50(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright84c28799418d4a24Ad0289586903bd50" parentTag={buildClassName("Copyright84c28799418d4a24Ad0289586903bd50", parentTag)} {...props} />
  );
}

// id: "e7a2b901-dd30-4538-a0be-3594c02e0ba2"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "8ad4eb17-bfd7-4251-88d1-6f415901827c"
export function LinksE7a2b901Dd304538A0be3594c02e0ba2(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksE7a2b901Dd304538A0be3594c02e0ba2" parentTag={buildClassName("LinksE7a2b901Dd304538A0be3594c02e0ba2", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "97075f2e-a844-48e4-b43d-208d7fa5126b"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "8ad4eb17-bfd7-4251-88d1-6f415901827c"
export function Groupflow97075f2eA84448e4B43d208d7fa5126b(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow97075f2eA84448e4B43d208d7fa5126b" parentTag={buildClassName("Groupflow97075f2eA84448e4B43d208d7fa5126b", parentTag)} {...props} />
  );
}

// id: "6f56d7fe-8355-4439-ae80-750b79da609b"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "fb7114b9-a151-4736-9206-4b6c312b2c6f"
export const LogoType6f56d7fe83554439Ae80750b79da609b = "FOOTER";

// id: "b82ad9a0-0114-43c4-8923-c533f6ad5b88"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "e7a2b901-dd30-4538-a0be-3594c02e0ba2"
export const NavMenuSlugB82ad9a0011443c48923C533f6ad5b88 = "footer-nav";

// id: "c3fa2bc4-7c8a-441c-9ff4-7f6b12115788"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "fb7114b9-a151-4736-9206-4b6c312b2c6f"
export const ContentSlugC3fa2bc47c8a441c9ff47f6b12115788 = "footer-logo";

const Components = {
  DefaultFooter8ad4eb17Bfd7425188d16f415901827c,
  LogoFb7114b9A151473692064b6c312b2c6f,
  Copyright84c28799418d4a24Ad0289586903bd50,
  LinksE7a2b901Dd304538A0be3594c02e0ba2,
  Groupflow97075f2eA84448e4B43d208d7fa5126b,
  LogoType6f56d7fe83554439Ae80750b79da609b,
  NavMenuSlugB82ad9a0011443c48923C533f6ad5b88,
  ContentSlugC3fa2bc47c8a441c9ff47f6b12115788
}

export default Components;